import React from "react";
import {Route, Redirect} from "react-router-dom";
import './MainPageStyle.css';
import GetAppData from "../../../client/components/Common/GetAppData";
import Header from './Header/Header';
import Dashboard from './DashboardPage/DashboardPage';
import Sites from './SitesPage/SitesPage';
import Configuration from './ConfigurationPage/ConfigurationPage';
import FieldsPage from './FieldsPage/FieldsPage';
import FieldPage from './FieldPage/FieldPage';
import UsersPage from './UsersPage/UsersPage';
import IntegrationsPage from './IntegrationsPage/IntegrationsPage';
import ReportsPage from './ReportsPage/ReportsPage';
import ProfilePage from './ProfilePage/ProfilePage';
import SettingsPageRoute from './SettingsPage/SettingsPageRoute';
import Clients from './ClientsPage/ClientsPage';
import RulesPage from './RulesPage/RulesPage';
import RulePage from './RulePage/RulePage';
import QueryString from 'qs';

export default class MainComponent extends React.Component{
    constructor(props){
        super(props);
        this.state = {hasError: false, pageID: '',siteVersionId: '', AppData: GetAppData.fromLocal(), flgVersion: false,dobYearDigitsFixARP67461: false,queryString : '',isActive:false, apiOptimizatioInRuleConfig: false};
        if (this.props.location.search) {

            this.state.queryString = QueryString.parse(this.props.location.search, { ignoreQueryPrefix: true });
        }
        
                this.state.queryString = "MainPage";
                this.state.flgVersion = false;
                this.state.isActive = false;
         
    }

    getApplicationData = () => {
        GetAppData.fromAPI(this.state.pageID, this.state.flgVersion, this.state.isActive, this.state.queryString, (error, response,responseData,apiOptimizatioInRuleConfig) => {
            if(error){
                alert('Internal server error, please try after sometime.');
                return;
            }
              this.setState({dobYearDigitsFixARP67461: responseData});
			  this.setState({apiOptimizatioInRuleConfig:apiOptimizatioInRuleConfig});

           
        });
        
    }

    getReferer = () => {
        var parser = document.createElement('a');
        parser.href = document.referrer;
        return parser.hostname;
    }
    componentDidMount = () =>{
        
            this.getApplicationData();      
       
    }
    getAppData = () => {
    }
    render(){
        return(
            <div>
                <Route component={Header} />
                <Route exact path={this.props.match.url+"/dashboard" } component={(args) => <Dashboard showNotification={this.props.showNotification} {...args}/>}/>
                <Route exact path={this.props.match.url+"/sites" } component={(args) => <Sites showNotification={this.props.showNotification} {...args}/>}/>
                <Route exact path={this.props.match.url+"/configuration" } component={(args) => <Configuration showNotification={this.props.showNotification} {...args}/>} />
                <Route exact path={this.props.match.url+"/fields" } component={(args) => <FieldsPage showNotification={this.props.showNotification} {...args}/>} />
                <Route exact path={this.props.match.url+"/rules" } component={(args) => <RulesPage showNotification={this.props.showNotification} {...args}/>} />
                <Route exact path={this.props.match.url+"/field/:mode/:id" } component={(args) => <FieldPage showNotification={this.props.showNotification}   {...args} dobYearDigitsFixARP67461 = {this.state.dobYearDigitsFixARP67461} />} />
                <Route exact path={this.props.match.url+"/rule/:mode/:id" } component={(args) => <RulePage showNotification={this.props.showNotification} {...args} apiOptimizatioInRuleConfig = {this.state.apiOptimizatioInRuleConfig} />} />
                <Route exact path={this.props.match.url+"/users" } component={(args) => <UsersPage showNotification={this.props.showNotification} {...args} />} />
                <Route exact path={this.props.match.url+"/integrations" } component={IntegrationsPage} />
                <Route exact path={this.props.match.url+"/reports" } component={ReportsPage} />
                <Route exact path={this.props.match.url+"/profile" } component={ProfilePage} />
                <Route path={this.props.match.url+"/site/:sitId/settings" } component={(args) => <SettingsPageRoute showNotification={this.props.showNotification} {...args}/>} />
                <Route exact path={this.props.match.url + "/"} component={() => <Redirect to={this.props.match.url + "/dashboard"} />} />
                {
                    (this.getReferer() === "baseline-qa.defidirect.com" || this.getReferer() === "baseline.defidirect.com") &&
                    <Route exact path={this.props.match.url + "/clients"} component={(args) => <Clients showNotification={this.props.showNotification} {...args} />} />
                }
           </div>
    )
}
}


// WEBPACK FOOTER //
// ./src/admin/components/Main/MainPage.js